import {HttpResult} from "widgets-for-react"
import axios from "axios"
import { Moment } from "moment"
import { List } from "immutable"
import { moment } from "../public_site/utils/moment"

type UnparsedEvent = {
  Categories: string[]
  Creator: string
  Description: string
  Link: string
  Location: string
  Newsletter: string
  PublishingDate: Date
  StartDate: Date
  Title: string
  Source: string
}

export type Event = {
  categories: string[]
  creator: string
  description: string
  link: string
  location: string
  newsletter: string
  publishingDate: Moment
  startDate: Moment
  title: string
  source: string
}

interface getEventParams {
  eventCategory: string
  numberOfEvents?: number
  blockedEvents?: string
}

export const getEvents: (category: string, numberOfEvents?: number, blockedEvents?: string[]) => Promise<HttpResult<Event[]>> = (
  category: string,
  numberOfEvents?: number,
  blockedEvents?: string[]
) => {
  let params: getEventParams = { eventCategory: category }
  if (numberOfEvents) params = {...params, numberOfEvents }
  if (blockedEvents)  params = {...params, blockedEvents: blockedEvents.map(block => block.toLowerCase().replace(/[^0-9a-z]/gi, '')).join('$') }

  return axios
    .get<UnparsedEvent[]>('/api/v1/events', { params })
    .then(response => {
      return response.data
        ? {
            kind: 'result' as 'result',
            value: response.data
              .map<Event>(e => ({
                categories: e.Categories,
                creator: e.Creator,
                description: e.Description,
                link: e.Link,
                location: e.Location,
                newsletter: e.Newsletter,
                publishingDate: moment(e.PublishingDate),
                startDate: moment(e.StartDate),
                title: e.Title,
                source: e.Source
              }))
              .sort((a, b) => a.startDate.diff(b.startDate)),
            status: 200
          }
        : { kind: 'failed' as 'failed', status: response.headers.status }
    })
    .catch(error => {
      return { kind: 'failed' as 'failed', status: error.response.headers.status }
    })
}
